import React from 'react';
import { Breaker } from 'types/Breaker';

import { LazyLoadImage } from 'react-lazy-load-image-component';

import placeholder from '../../assets/img/breaker-placeholder.png';

import 'react-lazy-load-image-component/src/effects/blur.css';
import 'simplebar/dist/simplebar.min.css';
import './BreakerCard.scss';

type Props = {
  breaker: Breaker;
  setSelectedBreaker: (breakerId: number) => void;
};

const BreakerCard = ({ breaker, setSelectedBreaker }: Props) => {
  const { id, isCanon, name, imageUrls } = breaker;

  return (
    <div
      className="breaker-card-container"
      onClick={() => {
        setSelectedBreaker(id);
      }}
    >
      <div className={`breaker-card ${isCanon ? 'is-canon' : ''}`}>
        <LazyLoadImage
          className="breaker-image img-fluid shadow-sm rounded"
          alt={name}
          src={imageUrls.thumbnail}
          placeholderSrc={placeholder}
          effect="blur"
        />
        <div className="text-center text-small d-block pt-2">{name}</div>
      </div>
    </div>
  );
};

export default BreakerCard;
